/**
 * global.js — Kawaicafe
 * Lógica base sin estilo. Controla la apertura/cierre del cart drawer (sidecart)
 * y del menú móvil mediante atributos data-*. Amplía a medida que construyes.
 */
(function () {
  'use strict';

  function openDrawer(el) {
    if (!el) return;
    el.setAttribute('data-open', 'true');
    // a11y: el aria-hidden="true" horneado debe quitarse al abrir (QA §5.5) —
    // si no, el lector de pantalla no "ve" el carrito abierto.
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.setAttribute('data-drawer-open', 'true');
  }

  function closeDrawer(el) {
    if (!el) return;
    el.removeAttribute('data-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.removeAttribute('data-drawer-open');
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-cart-open]');
    if (openTrigger) {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) {
        // En /cart el carrito ES la pagina: no hay panel que abrir. Si el carrito
        // ya esta en pantalla se sube a el (recargar perderia el scroll y cualquier
        // +/- en vuelo); si no lo esta, se deja navegar al enlace.
        var page = document.querySelector('[data-cart-page]');
        if (!page) return;
        event.preventDefault();
        page.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      event.preventDefault();
      openDrawer(drawer);
      return;
    }

    var closeTrigger = event.target.closest('[data-cart-close], [data-drawer-overlay]');
    if (closeTrigger) {
      event.preventDefault();
      closeDrawer(closeTrigger.closest('[data-cart-drawer]') || document.querySelector('[data-cart-drawer]'));
      return;
    }

    var menuToggle = event.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      event.preventDefault();
      var menu = document.querySelector('[data-mobile-menu]');
      if (menu) menu.toggleAttribute('data-open');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer(document.querySelector('[data-cart-drawer][data-open]'));
    }
  });
})();
